import { type FunctionComponent } from "react";
import { Card, Tabs } from "antd";
import { useTranslation } from "react-i18next";

import { RequestStatus } from "@fitness-app/app-store";

import InstallmentsCollection from "~/modules/Products/InstallmentsCollection/InstallmentsCollection";
import { ProductCheckoutVariantStatsTab } from "~/modules/Products/Product/ProductDetails/components/ProductCheckoutVariantStatsTab";
import { ProductCohortRetentionStats } from "~/modules/Products/Product/ProductDetails/components/ProductCohortRetentionStats";
import { useAppSelector } from "~/store/initializeStore";

interface ProductAnalyticsProps {
  productId: string;
}

/**
 * Everything that measures the product: checkout statistics, renewal cohorts and installment
 * collection. Each sub-tab is destroyed when left — they each pull their own report.
 */
const ProductAnalytics: FunctionComponent<ProductAnalyticsProps> = ({ productId }) => {
  const { t } = useTranslation(["products", "common"]);
  const { details, productDetailsStatus } = useAppSelector((store) => store.product);

  return (
    <Card loading={productDetailsStatus === RequestStatus.SUBSCRIBING && !details}>
      <Tabs defaultActiveKey="stats">
        <Tabs.TabPane key="stats" tab="Statystyki" destroyInactiveTabPane>
          <ProductCheckoutVariantStatsTab productId={productId} prices={details?.prices ?? []} />
        </Tabs.TabPane>
        <Tabs.TabPane key="cohorts" tab="Kohorty i retencja" destroyInactiveTabPane>
          <ProductCohortRetentionStats productId={productId} prices={details?.prices ?? []} />
        </Tabs.TabPane>
        <Tabs.TabPane key="installments" tab={t("installmentsCollection")} destroyInactiveTabPane>
          <InstallmentsCollection productId={productId} />
        </Tabs.TabPane>
      </Tabs>
    </Card>
  );
};

export default ProductAnalytics;
